import React, {forwardRef} from 'react';
import {Handle} from "./Handle";
import {stores} from "../../stores";
import {getPresetParameter} from "../../model";
import {getDisplayPresetNumber} from "../../utils/styling";

export const OverlayItem = forwardRef(({id, num, ...props}, ref) => {
    // Get the display preset number with offset applied if needed
    const displayNum = getDisplayPresetNumber(num, stores);

    return (
        <div className={`preset-selector overlay`} {...props} ref={ref}>
            {/* If you were displaying the number here, use displayNum instead of num */}
            {/* <div className="preset-number">{displayNum}</div> */}
            <div>
                <div className="preset-name">{stores.memory.getText(getPresetParameter("NAME"), num)}</div>
                <div className="preset-tempo">♩ {stores.memory.getValue(getPresetParameter("TEMPO"), num)}</div>
            </div>
            <div className="handle-wrapper">
                <Handle />
            </div>
        </div>
    );
});